export default "/assets/images/rookie-parent2.png?904d7f15afa1e4d435c5b02f4f8cc28d";